import React from 'react';
import './RadioInput.scss';

interface RadioInputProps {
  id: string;
  name: string;
  value: string;
  label: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  required?: boolean;
}

const RadioInput: React.FC<RadioInputProps> = ({
  id,
  name,
  value,
  label,
  checked = false,
  disabled = false,
  onChange,
  className = '',
  required = false
}) => {
  return (
    <label 
      className={`radio-input ${disabled ? 'radio-input--disabled' : ''} ${className}`}
      htmlFor={id}
    >
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className="radio-input__input"
        required={required}
      />
      <div className="radio-input__button" />
      <span className="radio-input__label">{label}</span>
    </label>
  );
};

export default RadioInput;